import * as React from "react";
const SvgFiRrWagonCovered = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wagon-covered_svg__a)">
      <path
        fill="#062147"
        d="M23.239 1.465A2.69 2.69 0 0 0 20.81.682l-.41.083Q19.706.924 19 1c-1 0-1.991-1-3-1s-2.5 1-4 1-3.012-1-4.006-1S6 1 5 1Q4.295.924 3.605.765L3.192.683a2.68 2.68 0 0 0-2.431.782 2.71 2.71 0 0 0-.695 2.483L2 13.105V20a4.005 4.005 0 0 0 7.873 1h4.254A4.004 4.004 0 0 0 22 20v-6.895l1.93-9.139a2.72 2.72 0 0 0-.691-2.501M2.199 2.85a.68.68 0 0 1 .622-.2l.377.076A4.77 4.77 0 0 0 7 2.457V9a1 1 0 0 0 2 0V2.3a8.4 8.4 0 0 0 3 .7 8.4 8.4 0 0 0 3-.7V9a1 1 0 1 0 2 0V2.457a4.76 4.76 0 0 0 3.8.267l.379-.077a.67.67 0 0 1 .619.2.73.73 0 0 1 .181.684L20.189 12H3.811L2.02 3.517a.72.72 0 0 1 .18-.667M14.128 19H9.873A4.032 4.032 0 0 0 4 16.537V14h16v2.537A4.033 4.033 0 0 0 14.127 19M6 22a2 2 0 1 1 0-4 2 2 0 0 1 0 4m12 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wagon-covered_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWagonCovered;
